import { isString } from "lodash";
import { StringFormat } from "utils/format/StringFormat";

export abstract class BasedB2CTransactionResponseModel {
  createdAt?: string;
  updatedAt?: string;
  type?: number;
  status?: number;
  name?: string;
  code?: string;
  transRef?: string | null;
  totalAmount?: string;
  description?: string | null;
  note?: string | null;
  order?: number;
  currency?: string;
  beforeCredit?: string;
  afterCredit?: string;
  commissionAmount?: string;

  constructor(data?: Partial<BasedB2CTransactionResponseModel>) {
    Object.assign(this, data || {});
    this.beforeCredit = this.convertCredit("beforeCredit");
    this.afterCredit = this.convertCredit("afterCredit");
  }

  public convertCredit?(keyType: "beforeCredit" | "afterCredit") {
    return isString(this.note)
      ? (StringFormat.parseNoteString(this.note)?.[keyType] as string)
      : "0";
  }
}
